export const translations = {
  en: {
    nav: {
      services: 'Services',
      about: 'About',
      team: 'Team',
      testimonials: 'Testimonials',
      contact: 'Contact',
      exploreSolutions: 'Explore Solutions',
    },
    hero: {
      headline: 'Smarter Logistics. Better Technology. Real Results.',
      subtext: 'Alceylan Enterprises delivers end-to-end logistics management, online food ordering platforms, food truck location systems, and custom software solutions for businesses ready to grow.',
      exploreSolutions: 'Explore Solutions',
      partnerWithUs: 'Partner With Us',
    },
    services: {
      overline: 'OUR SOLUTIONS',
      title: 'What We Build',
      ai: {
        title: 'Emergent AI Solutions',
        description: 'AI consulting and solution development leveraging cutting-edge machine learning, neural networks, and intelligent automation to transform your business operations.',
      },
      saas: {
        title: 'Custom Software Development',
        description: 'Tailored software solutions built for your business — from ERP systems and CRM platforms to fully custom web and mobile applications.',
      },
      joinzy: {
        title: 'Joinzy - Social Media Platform',
        description: 'Our flagship social platform connecting communities with powerful tools for engagement, networking, and content sharing.',
      },
      logistics: {
        title: 'Logistics & Supply Chain Systems',
        description: 'End-to-end logistics management solutions including real-time tracking, route optimization, supply chain coordination, and ERP integrations for global operations.',
      },
      gaming: {
        title: 'Food Ordering & Location Systems',
        description: 'Online food ordering platforms and food truck location systems that connect customers with vendors in real time — built for speed, reliability, and scale.',
      },
    },
    about: {
      overline: 'WHO WE ARE',
      title: 'Technology That Moves Business Forward',
      p1: 'Alceylan Enterprises is a technology company building practical, high-performance solutions for logistics, food & beverage, and digital platforms. We combine deep industry knowledge with strong engineering to deliver software that works in the real world.',
      p2: 'From logistics management and supply chain systems to food ordering platforms and social applications, we build products that solve real problems and scale with your business.',
      p3: 'We partner closely with our clients from day one — understanding their operations, designing the right solution, and supporting them long after launch.',
    },
    team: {
      overline: 'LEADERSHIP',
      title: 'Meet Our Team',
      members: {
        ceo: { name: 'Arslan Ceylan', title: 'Founder & CEO' },
        ai: { name: 'Elena Rostova', title: 'Head of Emergent AI' },
        logistics: { name: 'Marcus Chen', title: 'VP of Logistics & CRM' },
      },
    },
    testimonials: {
      overline: 'TESTIMONIALS',
      title: 'What Our Clients Say',
      partners: 'Trusted Partners',
      items: [
        {
          quote: "Alceylan's AI solutions transformed our operational efficiency by 40%. Their expertise in emergent AI technologies is unparalleled.",
          author: "Zahide Yildiz",
          role: "Eureka Logistics CEO Founder",
        },
        {
          quote: "The custom ERP system they built for us seamlessly integrates with our global logistics network. Exceptional quality and support.",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: 'GET IN TOUCH',
      title: 'Start Your Project',
      newsletter: {
        title: 'Stay Updated',
        description: 'Subscribe to our newsletter for the latest insights in enterprise technology.',
        placeholder: 'Enter your email',
        button: 'Subscribe',
        success: 'Successfully subscribed!',
      },
      form: {
        name: 'Full Name',
        email: 'Email Address',
        service: 'Service Interest',
        selectService: 'Select a service',
        message: 'Message',
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully! We will get back to you soon.',
        error: 'Failed to send message. Please try again.',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    legal: {
      lastUpdated: 'Last Updated',
      privacy: {
        intro: {
          title: 'Introduction',
          content: 'Alceylan Enterprises ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
        },
        collection: {
          title: 'Information We Collect',
          content: 'We may collect information about you in a variety of ways:',
          items: [
            'Personal Data: Name, email address, phone number, and company information you provide through our contact forms.',
            'Usage Data: Information about how you access and use our website, including IP address, browser type, and pages visited.',
            'Cookies: Small data files stored on your device to enhance your browsing experience.',
          ],
        },
        usage: {
          title: 'How We Use Your Information',
          content: 'We use the information we collect to:',
          items: [
            'Respond to your inquiries and provide customer support',
            'Send you newsletters and marketing communications (with your consent)',
            'Improve our website and services',
            'Comply with legal obligations',
          ],
        },
        security: {
          title: 'Data Security',
          content: 'We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.',
        },
        cookies: {
          title: 'Cookies and Tracking',
          content: 'We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.',
        },
        rights: {
          title: 'Your Rights',
          content: 'Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, delete, or export your data. To exercise these rights, please contact us using the information below.',
        },
        contact: {
          title: 'Contact Us',
          content: 'If you have questions about this Privacy Policy or our data practices, please contact us at:',
        },
      },
      terms: {
        acceptance: {
          title: 'Acceptance of Terms',
          content: 'By accessing and using the services provided by Alceylan Enterprises, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.',
        },
        services: {
          title: 'Our Services',
          content: 'Alceylan Enterprises provides technology consulting, software development, AI solutions, logistics systems, and related services. We reserve the right to modify, suspend, or discontinue any service at any time without prior notice.',
        },
        intellectual: {
          title: 'Intellectual Property',
          content: 'All content, trademarks, logos, and intellectual property displayed on this website are the property of Alceylan Enterprises or their respective owners. You may not reproduce, distribute, or create derivative works without our express written permission.',
        },
        liability: {
          title: 'Limitation of Liability',
          content: 'Alceylan Enterprises shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount paid by you for the specific service in question.',
        },
        confidentiality: {
          title: 'Confidentiality',
          content: 'Both parties agree to maintain the confidentiality of any proprietary or sensitive information shared during the course of our business relationship. This obligation survives the termination of any agreement.',
        },
        termination: {
          title: 'Termination',
          content: 'We may terminate or suspend your access to our services immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use our services will cease immediately.',
        },
        governing: {
          title: 'Governing Law',
          content: 'These Terms shall be governed by and construed in accordance with applicable international commercial laws. Any disputes arising from these terms will be resolved through arbitration or in the courts of the applicable jurisdiction.',
        },
        contact: {
          title: 'Contact Information',
          content: 'For any questions regarding these Terms of Service, please contact us at:',
        },
      },
    },
  },
  de: {
    nav: {
      services: 'Dienstleistungen',
      about: 'Über uns',
      team: 'Team',
      testimonials: 'Referenzen',
      contact: 'Kontakt',
      exploreSolutions: 'Lösungen entdecken',
    },
    hero: {
      headline: 'Emergent AI nutzen. Die Zukunft gestalten.',
      subtext: 'Ein vielfältiges technologisches Ökosystem, das die Unternehmensentwicklung durch fortschrittliche KI, maßgeschneiderte SaaS-Plattformen und globale Logistiklösungen vorantreibt.',
      exploreSolutions: 'Lösungen entdecken',
      partnerWithUs: 'Partner werden',
    },
    services: {
      overline: 'UNSERE LÖSUNGEN',
      title: 'Enterprise-Technologie-Stack',
      ai: {
        title: 'Emergent AI-Lösungen',
        description: 'KI-Beratung und Lösungsentwicklung mit modernsten Machine-Learning-, neuronalen Netzwerk- und intelligenten Automatisierungstechnologien.',
      },
      saas: {
        title: 'Enterprise SaaS-Plattformen',
        description: 'Maßgeschneiderte Softwarelösungen einschließlich robuster ERP-Systeme und CRM-Plattformen für Ihre spezifischen Geschäftsanforderungen.',
      },
      joinzy: {
        title: 'Joinzy - Soziales Ökosystem',
        description: 'Unsere führende Social-Media-Plattform, die Gemeinschaften mit innovativen Funktionen für Engagement und Networking verbindet.',
      },
      logistics: {
        title: 'Fortschrittliche Logistiksysteme',
        description: 'Umfassende Logistikmanagement- und ERP-Lösungen für globale Operationen, Supply-Chain-Optimierung und Echtzeit-Tracking.',
      },
      gaming: {
        title: 'Online-Spieleentwicklung',
        description: 'Immersive Spielerlebnisse mit modernster Grafik, Multiplayer-Infrastruktur und fesselnder Spielmechanik.',
      },
    },
    about: {
      overline: 'UNSERE EXPERTISE',
      title: 'Vertrauen durch technische Exzellenz aufbauen',
      p1: 'Bei Alceylan Enterprises stehen wir an der Schnittstelle von Innovation und Zuverlässigkeit. Unser Team aus erstklassigen Ingenieuren, Datenwissenschaftlern und Unternehmensstrategien arbeitet zusammen, um Lösungen zu liefern, die Erwartungen übertreffen.',
      p2: 'Mit einem Qualitätsanspruch, der jedes Projekt durchzieht, haben wir uns als vertrauenswürdiger Partner für Unternehmen etabliert, die eine digitale Transformation anstreben.',
      p3: 'Von der Konzeptualisierung bis zur Bereitstellung bieten wir End-to-End-Support, der unseren Kunden hilft, ihre strategischen Ziele mit Zuversicht zu erreichen.',
    },
    team: {
      overline: 'FÜHRUNG',
      title: 'Unser Team kennenlernen',
      members: {
        ceo: { name: 'Arslan Ceylan', title: 'Gründer & CEO' },
        ai: { name: 'Elena Rostova', title: 'Leiterin Emergent AI' },
        logistics: { name: 'Marcus Chen', title: 'VP Logistik & CRM' },
      },
    },
    testimonials: {
      overline: 'REFERENZEN',
      title: 'Was unsere Kunden sagen',
      partners: 'Vertrauenswürdige Partner',
      items: [
        {
          quote: "Die KI-Lösungen von Alceylan haben unsere betriebliche Effizienz um 40% gesteigert. Ihre Expertise in emergenten KI-Technologien ist unübertroffen.",
          author: "Zahide Yildiz",
          role: "Eureka Logistics CEO Founder",
        },
        {
          quote: "Das maßgeschneiderte ERP-System integriert sich nahtlos in unser globales Logistiknetzwerk. Außergewöhnliche Qualität und Support.",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: 'KONTAKT',
      title: 'Starten Sie Ihr Projekt',
      newsletter: {
        title: 'Bleiben Sie informiert',
        description: 'Abonnieren Sie unseren Newsletter für die neuesten Einblicke in Unternehmenstechnologie.',
        placeholder: 'E-Mail eingeben',
        button: 'Abonnieren',
        success: 'Erfolgreich abonniert!',
      },
      form: {
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        service: 'Serviceinteresse',
        selectService: 'Service auswählen',
        message: 'Nachricht',
        submit: 'Nachricht senden',
        sending: 'Wird gesendet...',
        success: 'Nachricht erfolgreich gesendet! Wir melden uns bald.',
        error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. Alle Rechte vorbehalten.',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
    },
    legal: {
      lastUpdated: 'Zuletzt aktualisiert',
      privacy: {
        intro: {
          title: 'Einführung',
          content: 'Alceylan Enterprises ("wir", "unser" oder "uns") verpflichtet sich zum Schutz Ihrer Privatsphäre. Diese Datenschutzerklärung erklärt, wie wir Ihre Informationen sammeln, verwenden, offenlegen und schützen.',
        },
        collection: {
          title: 'Informationen, die wir sammeln',
          content: 'Wir können Informationen über Sie auf verschiedene Arten sammeln:',
          items: [
            'Persönliche Daten: Name, E-Mail-Adresse, Telefonnummer und Unternehmensinformationen, die Sie über unsere Kontaktformulare angeben.',
            'Nutzungsdaten: Informationen darüber, wie Sie auf unsere Website zugreifen und diese nutzen.',
            'Cookies: Kleine Datendateien, die auf Ihrem Gerät gespeichert werden, um Ihr Surferlebnis zu verbessern.',
          ],
        },
        usage: {
          title: 'Wie wir Ihre Informationen verwenden',
          content: 'Wir verwenden die gesammelten Informationen, um:',
          items: [
            'Auf Ihre Anfragen zu antworten und Kundensupport zu bieten',
            'Ihnen Newsletter und Marketingmitteilungen zu senden (mit Ihrer Zustimmung)',
            'Unsere Website und Dienstleistungen zu verbessern',
            'Gesetzlichen Verpflichtungen nachzukommen',
          ],
        },
        security: {
          title: 'Datensicherheit',
          content: 'Wir implementieren angemessene technische und organisatorische Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Daten gegen unbefugten Zugriff, Änderung, Offenlegung oder Zerstörung.',
        },
        cookies: {
          title: 'Cookies und Tracking',
          content: 'Wir verwenden Cookies und ähnliche Tracking-Technologien, um die Aktivität auf unserer Website zu verfolgen. Sie können Ihren Browser anweisen, alle Cookies abzulehnen.',
        },
        rights: {
          title: 'Ihre Rechte',
          content: 'Je nach Ihrem Standort haben Sie möglicherweise bestimmte Rechte bezüglich Ihrer persönlichen Daten, einschließlich des Rechts auf Zugang, Berichtigung, Löschung oder Export Ihrer Daten.',
        },
        contact: {
          title: 'Kontakt',
          content: 'Bei Fragen zu dieser Datenschutzerklärung kontaktieren Sie uns bitte unter:',
        },
      },
      terms: {
        acceptance: {
          title: 'Annahme der Bedingungen',
          content: 'Durch den Zugriff auf und die Nutzung der von Alceylan Enterprises bereitgestellten Dienste erklären Sie sich mit diesen Nutzungsbedingungen einverstanden.',
        },
        services: {
          title: 'Unsere Dienstleistungen',
          content: 'Alceylan Enterprises bietet Technologieberatung, Softwareentwicklung, KI-Lösungen, Logistiksysteme und verwandte Dienstleistungen an.',
        },
        intellectual: {
          title: 'Geistiges Eigentum',
          content: 'Alle auf dieser Website angezeigten Inhalte, Marken, Logos und geistigen Eigentum sind Eigentum von Alceylan Enterprises oder ihren jeweiligen Eigentümern.',
        },
        liability: {
          title: 'Haftungsbeschränkung',
          content: 'Alceylan Enterprises haftet nicht für indirekte, zufällige, besondere, Folge- oder Strafschäden, die sich aus Ihrer Nutzung unserer Dienste ergeben.',
        },
        confidentiality: {
          title: 'Vertraulichkeit',
          content: 'Beide Parteien verpflichten sich, die Vertraulichkeit aller proprietären oder sensiblen Informationen zu wahren, die während unserer Geschäftsbeziehung ausgetauscht werden.',
        },
        termination: {
          title: 'Kündigung',
          content: 'Wir können Ihren Zugang zu unseren Diensten jederzeit ohne vorherige Ankündigung beenden oder aussetzen.',
        },
        governing: {
          title: 'Anwendbares Recht',
          content: 'Diese Bedingungen unterliegen den geltenden internationalen Handelsgesetzen und werden entsprechend ausgelegt.',
        },
        contact: {
          title: 'Kontaktinformationen',
          content: 'Bei Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns bitte unter:',
        },
      },
    },
  },
  es: {
    nav: {
      services: 'Servicios',
      about: 'Nosotros',
      team: 'Equipo',
      testimonials: 'Testimonios',
      contact: 'Contacto',
      exploreSolutions: 'Explorar Soluciones',
    },
    hero: {
      headline: 'Aprovechando la IA Emergente. Estructurando el Futuro.',
      subtext: 'Un ecosistema tecnológico diverso que impulsa la evolución empresarial a través de IA avanzada, plataformas SaaS personalizadas y soluciones logísticas globales.',
      exploreSolutions: 'Explorar Soluciones',
      partnerWithUs: 'Asóciate con Nosotros',
    },
    services: {
      overline: 'NUESTRAS SOLUCIONES',
      title: 'Stack Tecnológico Empresarial',
      ai: {
        title: 'Soluciones de IA Emergente',
        description: 'Consultoría y desarrollo de soluciones de IA utilizando aprendizaje automático de vanguardia, redes neuronales y automatización inteligente.',
      },
      saas: {
        title: 'Plataformas SaaS Empresariales',
        description: 'Soluciones de software a medida que incluyen sistemas ERP robustos y plataformas CRM adaptadas a sus requisitos específicos.',
      },
      joinzy: {
        title: 'Joinzy - Ecosistema Social',
        description: 'Nuestra plataforma insignia de redes sociales que conecta comunidades con funciones innovadoras para el engagement y networking.',
      },
      logistics: {
        title: 'Sistemas Logísticos Avanzados',
        description: 'Soluciones integrales de gestión logística y ERP diseñadas para operaciones globales, optimización de cadena de suministro y seguimiento en tiempo real.',
      },
      gaming: {
        title: 'Desarrollo de Juegos Online',
        description: 'Creación de experiencias de juego inmersivas con gráficos de última generación, infraestructura multijugador y mecánicas de juego cautivadoras.',
      },
    },
    about: {
      overline: 'NUESTRA EXPERIENCIA',
      title: 'Construyendo Confianza a Través de la Excelencia Técnica',
      p1: 'En Alceylan Enterprises, nos encontramos en la intersección de la innovación y la fiabilidad. Nuestro equipo de ingenieros, científicos de datos y estrategas de negocios de clase mundial trabajan colaborativamente.',
      p2: 'Con un compromiso con la calidad que abarca cada proyecto, nos hemos establecido como un socio de confianza para empresas que buscan la transformación digital.',
      p3: 'Desde la conceptualización hasta la implementación, proporcionamos soporte de principio a fin, asegurando que nuestros clientes logren sus objetivos estratégicos con confianza.',
    },
    team: {
      overline: 'LIDERAZGO',
      title: 'Conoce a Nuestro Equipo',
      members: {
        ceo: { name: 'Arslan Ceylan', title: 'Fundador y CEO' },
        ai: { name: 'Elena Rostova', title: 'Directora de IA Emergente' },
        logistics: { name: 'Marcus Chen', title: 'VP de Logística y CRM' },
      },
    },
    testimonials: {
      overline: 'TESTIMONIOS',
      title: 'Lo Que Dicen Nuestros Clientes',
      partners: 'Socios de Confianza',
      items: [
        {
          quote: "Las soluciones de IA de Alceylan transformaron nuestra eficiencia operativa en un 40%. Su experiencia en tecnologías de IA emergente es incomparable.",
          author: "Zahide Yildiz",
          role: "Eureka Logistics CEO Founder",
        },
        {
          quote: "El sistema ERP personalizado se integra perfectamente con nuestra red logística global. Calidad y soporte excepcionales.",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: 'CONTÁCTANOS',
      title: 'Inicia Tu Proyecto',
      newsletter: {
        title: 'Mantente Actualizado',
        description: 'Suscríbete a nuestro boletín para las últimas novedades en tecnología empresarial.',
        placeholder: 'Ingresa tu email',
        button: 'Suscribirse',
        success: '¡Suscrito exitosamente!',
      },
      form: {
        name: 'Nombre Completo',
        email: 'Correo Electrónico',
        service: 'Servicio de Interés',
        selectService: 'Selecciona un servicio',
        message: 'Mensaje',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...',
        success: '¡Mensaje enviado exitosamente! Nos pondremos en contacto pronto.',
        error: 'Error al enviar. Por favor intenta de nuevo.',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
    },
    legal: {
      lastUpdated: 'Última actualización',
      privacy: {
        intro: {
          title: 'Introducción',
          content: 'Alceylan Enterprises ("nosotros", "nuestro" o "nos") se compromete a proteger su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos su información.',
        },
        collection: {
          title: 'Información que Recopilamos',
          content: 'Podemos recopilar información sobre usted de varias maneras:',
          items: [
            'Datos Personales: Nombre, dirección de correo electrónico, número de teléfono e información de la empresa que proporciona a través de nuestros formularios de contacto.',
            'Datos de Uso: Información sobre cómo accede y utiliza nuestro sitio web.',
            'Cookies: Pequeños archivos de datos almacenados en su dispositivo para mejorar su experiencia de navegación.',
          ],
        },
        usage: {
          title: 'Cómo Usamos su Información',
          content: 'Usamos la información que recopilamos para:',
          items: [
            'Responder a sus consultas y proporcionar soporte al cliente',
            'Enviarle boletines y comunicaciones de marketing (con su consentimiento)',
            'Mejorar nuestro sitio web y servicios',
            'Cumplir con obligaciones legales',
          ],
        },
        security: {
          title: 'Seguridad de Datos',
          content: 'Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.',
        },
        cookies: {
          title: 'Cookies y Seguimiento',
          content: 'Utilizamos cookies y tecnologías de seguimiento similares para rastrear la actividad en nuestro sitio web. Puede configurar su navegador para rechazar todas las cookies.',
        },
        rights: {
          title: 'Sus Derechos',
          content: 'Dependiendo de su ubicación, puede tener ciertos derechos con respecto a su información personal, incluyendo el derecho de acceso, corrección, eliminación o exportación de sus datos.',
        },
        contact: {
          title: 'Contáctenos',
          content: 'Si tiene preguntas sobre esta Política de Privacidad, contáctenos en:',
        },
      },
      terms: {
        acceptance: {
          title: 'Aceptación de Términos',
          content: 'Al acceder y utilizar los servicios proporcionados por Alceylan Enterprises, usted acepta estar sujeto a estos Términos de Servicio.',
        },
        services: {
          title: 'Nuestros Servicios',
          content: 'Alceylan Enterprises proporciona consultoría tecnológica, desarrollo de software, soluciones de IA, sistemas logísticos y servicios relacionados.',
        },
        intellectual: {
          title: 'Propiedad Intelectual',
          content: 'Todo el contenido, marcas comerciales, logotipos y propiedad intelectual mostrados en este sitio web son propiedad de Alceylan Enterprises o sus respectivos propietarios.',
        },
        liability: {
          title: 'Limitación de Responsabilidad',
          content: 'Alceylan Enterprises no será responsable por daños indirectos, incidentales, especiales, consecuentes o punitivos derivados del uso de nuestros servicios.',
        },
        confidentiality: {
          title: 'Confidencialidad',
          content: 'Ambas partes acuerdan mantener la confidencialidad de cualquier información propietaria o sensible compartida durante nuestra relación comercial.',
        },
        termination: {
          title: 'Terminación',
          content: 'Podemos terminar o suspender su acceso a nuestros servicios inmediatamente, sin previo aviso, por cualquier motivo.',
        },
        governing: {
          title: 'Ley Aplicable',
          content: 'Estos Términos se regirán e interpretarán de acuerdo con las leyes comerciales internacionales aplicables.',
        },
        contact: {
          title: 'Información de Contacto',
          content: 'Para cualquier pregunta sobre estos Términos de Servicio, contáctenos en:',
        },
      },
    },
  },
  zh: {
    nav: {
      services: '服务',
      about: '关于我们',
      team: '团队',
      testimonials: '客户评价',
      contact: '联系我们',
      exploreSolutions: '探索解决方案',
    },
    hero: {
      headline: '驾驭新兴AI。构建未来。',
      subtext: '多元化的技术生态系统，通过先进的AI、定制SaaS平台和全球物流解决方案推动企业发展。',
      exploreSolutions: '探索解决方案',
      partnerWithUs: '成为合作伙伴',
    },
    services: {
      overline: '我们的解决方案',
      title: '企业技术堆栈',
      ai: {
        title: '新兴AI解决方案',
        description: 'AI咨询和解决方案开发，利用最先进的机器学习、神经网络和智能自动化来转变您的业务运营。',
      },
      saas: {
        title: '企业SaaS平台',
        description: '定制软件解决方案，包括强大的ERP系统和CRM平台，量身定制以满足您的特定业务需求。',
      },
      joinzy: {
        title: 'Joinzy - 社交生态系统',
        description: '我们的旗舰社交媒体平台，通过创新功能连接社区，实现参与、网络和内容分享。',
      },
      logistics: {
        title: '先进物流系统',
        description: '为全球运营、供应链优化和实时跟踪设计的全面物流管理和ERP解决方案。',
      },
      gaming: {
        title: '在线游戏开发',
        description: '创造沉浸式游戏体验，拥有最先进的图形、多人游戏基础设施和引人入胜的游戏机制。',
      },
    },
    about: {
      overline: '我们的专业',
      title: '通过技术卓越建立信任',
      p1: '在Alceylan Enterprises，我们站在创新与可靠性的交汇处。我们世界级的工程师、数据科学家和业务战略家团队协同工作，提供超越期望的解决方案。',
      p2: '凭借贯穿每个项目的质量承诺，我们已成为寻求数字化转型的企业值得信赖的合作伙伴。',
      p3: '从概念化到部署，我们提供端到端支持，确保我们的客户充满信心地实现其战略目标。',
    },
    team: {
      overline: '领导团队',
      title: '认识我们的团队',
      members: {
        ceo: { name: 'Arslan Ceylan', title: '创始人兼首席执行官' },
        ai: { name: 'Elena Rostova', title: '新兴AI主管' },
        logistics: { name: 'Marcus Chen', title: '物流与CRM副总裁' },
      },
    },
    testimonials: {
      overline: '客户评价',
      title: '客户怎么说',
      partners: '值得信赖的合作伙伴',
      items: [
        {
          quote: "Alceylan的AI解决方案将我们的运营效率提高了40%。他们在新兴AI技术方面的专业知识无与伦比。",
          author: "Zahide Yildiz",
          role: "首席技术官，TechVentures Inc.",
        },
        {
          quote: "他们为我们构建的定制ERP系统与我们的全球物流网络无缝集成。卓越的质量和支持。",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: '联系我们',
      title: '开始您的项目',
      newsletter: {
        title: '保持更新',
        description: '订阅我们的新闻通讯，获取企业技术的最新见解。',
        placeholder: '输入您的邮箱',
        button: '订阅',
        success: '订阅成功！',
      },
      form: {
        name: '全名',
        email: '电子邮箱',
        service: '感兴趣的服务',
        selectService: '选择服务',
        message: '留言',
        submit: '发送消息',
        sending: '发送中...',
        success: '消息发送成功！我们会尽快与您联系。',
        error: '发送失败，请重试。',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. 保留所有权利。',
      privacy: '隐私政策',
      terms: '服务条款',
    },
    legal: {
      lastUpdated: '最后更新',
      privacy: {
        intro: {
          title: '简介',
          content: 'Alceylan Enterprises（"我们"）致力于保护您的隐私。本隐私政策解释了我们如何收集、使用、披露和保护您的信息。',
        },
        collection: {
          title: '我们收集的信息',
          content: '我们可能通过多种方式收集您的信息：',
          items: [
            '个人数据：您通过联系表单提供的姓名、电子邮件地址、电话号码和公司信息。',
            '使用数据：关于您如何访问和使用我们网站的信息。',
            'Cookie：存储在您设备上的小型数据文件，用于增强您的浏览体验。',
          ],
        },
        usage: {
          title: '我们如何使用您的信息',
          content: '我们使用收集的信息来：',
          items: [
            '回应您的询问并提供客户支持',
            '向您发送新闻通讯和营销通信（经您同意）',
            '改进我们的网站和服务',
            '遵守法律义务',
          ],
        },
        security: {
          title: '数据安全',
          content: '我们实施适当的技术和组织安全措施，以保护您的个人信息免受未经授权的访问、更改、披露或销毁。',
        },
        cookies: {
          title: 'Cookie和跟踪',
          content: '我们使用Cookie和类似的跟踪技术来跟踪我们网站上的活动。您可以指示浏览器拒绝所有Cookie。',
        },
        rights: {
          title: '您的权利',
          content: '根据您所在的位置，您可能对您的个人信息拥有某些权利，包括访问、更正、删除或导出您的数据的权利。',
        },
        contact: {
          title: '联系我们',
          content: '如果您对本隐私政策有疑问，请通过以下方式联系我们：',
        },
      },
      terms: {
        acceptance: {
          title: '接受条款',
          content: '通过访问和使用Alceylan Enterprises提供的服务，您同意受这些服务条款的约束。',
        },
        services: {
          title: '我们的服务',
          content: 'Alceylan Enterprises提供技术咨询、软件开发、AI解决方案、物流系统及相关服务。',
        },
        intellectual: {
          title: '知识产权',
          content: '本网站上显示的所有内容、商标、徽标和知识产权均为Alceylan Enterprises或其各自所有者的财产。',
        },
        liability: {
          title: '责任限制',
          content: 'Alceylan Enterprises不对因使用我们的服务而产生的任何间接、附带、特殊、后果性或惩罚性损害承担责任。',
        },
        confidentiality: {
          title: '保密性',
          content: '双方同意对在业务关系过程中共享的任何专有或敏感信息保密。',
        },
        termination: {
          title: '终止',
          content: '我们可能会立即终止或暂停您对我们服务的访问，恕不另行通知。',
        },
        governing: {
          title: '适用法律',
          content: '这些条款应受适用的国际商业法律管辖并据此解释。',
        },
        contact: {
          title: '联系信息',
          content: '如对这些服务条款有任何疑问，请通过以下方式联系我们：',
        },
      },
    },
  },
  ja: {
    nav: {
      services: 'サービス',
      about: '会社概要',
      team: 'チーム',
      testimonials: 'お客様の声',
      contact: 'お問い合わせ',
      exploreSolutions: 'ソリューションを探す',
    },
    hero: {
      headline: 'エマージェントAIを活用。未来を構築。',
      subtext: '先進的なAI、カスタムSaaSプラットフォーム、グローバルな物流ソリューションを通じて企業の進化を推進する多様なテクノロジーエコシステム。',
      exploreSolutions: 'ソリューションを探す',
      partnerWithUs: 'パートナーになる',
    },
    services: {
      overline: '私たちのソリューション',
      title: 'エンタープライズテクノロジースタック',
      ai: {
        title: 'エマージェントAIソリューション',
        description: '最先端の機械学習、ニューラルネットワーク、インテリジェントオートメーションを活用したAIコンサルティングとソリューション開発。',
      },
      saas: {
        title: 'エンタープライズSaaSプラットフォーム',
        description: '堅牢なERPシステムとCRMプラットフォームを含む、お客様固有のビジネス要件に合わせたカスタムソフトウェアソリューション。',
      },
      joinzy: {
        title: 'Joinzy - ソーシャルエコシステム',
        description: 'エンゲージメント、ネットワーキング、コンテンツ共有のための革新的な機能でコミュニティを繋ぐ旗艦ソーシャルメディアプラットフォーム。',
      },
      logistics: {
        title: '先進物流システム',
        description: 'グローバルオペレーション、サプライチェーン最適化、リアルタイムトラッキングのための包括的な物流管理およびERPソリューション。',
      },
      gaming: {
        title: 'オンラインゲーム開発',
        description: '最先端のグラフィックス、マルチプレイヤーインフラストラクチャ、魅力的なゲームプレイメカニクスで没入型ゲーム体験を創造。',
      },
    },
    about: {
      overline: '私たちの専門性',
      title: '技術的卓越性を通じて信頼を築く',
      p1: 'Alceylan Enterprisesでは、イノベーションと信頼性の交差点に立っています。世界クラスのエンジニア、データサイエンティスト、ビジネスストラテジストからなるチームが協力して、期待を超えるソリューションを提供します。',
      p2: 'すべてのプロジェクトに及ぶ品質へのコミットメントにより、デジタルトランスフォーメーションを求める企業の信頼できるパートナーとしての地位を確立しました。',
      p3: 'コンセプト化から展開まで、エンドツーエンドのサポートを提供し、クライアントが自信を持って戦略目標を達成できるようにします。',
    },
    team: {
      overline: 'リーダーシップ',
      title: '私たちのチーム',
      members: {
        ceo: { name: 'Arslan Ceylan', title: '創業者兼CEO' },
        ai: { name: 'Elena Rostova', title: 'エマージェントAI責任者' },
        logistics: { name: 'Marcus Chen', title: '物流・CRM担当VP' },
      },
    },
    testimonials: {
      overline: 'お客様の声',
      title: 'クライアントからの評価',
      partners: '信頼されるパートナー',
      items: [
        {
          quote: "AlceylanのAIソリューションは、私たちの業務効率を40%向上させました。エマージェントAI技術における彼らの専門知識は比類ありません。",
          author: "Zahide Yildiz",
          role: "Eureka Logistics CEO Founder",
        },
        {
          quote: "彼らが構築したカスタムERPシステムは、私たちのグローバル物流ネットワークとシームレスに統合されています。卓越した品質とサポート。",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: 'お問い合わせ',
      title: 'プロジェクトを始める',
      newsletter: {
        title: '最新情報を入手',
        description: 'ニュースレターを購読して、エンタープライズテクノロジーの最新情報を入手してください。',
        placeholder: 'メールアドレスを入力',
        button: '購読',
        success: '購読成功！',
      },
      form: {
        name: 'お名前',
        email: 'メールアドレス',
        service: '関心のあるサービス',
        selectService: 'サービスを選択',
        message: 'メッセージ',
        submit: '送信',
        sending: '送信中...',
        success: 'メッセージが送信されました！折り返しご連絡いたします。',
        error: '送信に失敗しました。もう一度お試しください。',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. All rights reserved.',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
    },
    legal: {
      lastUpdated: '最終更新日',
      privacy: {
        intro: {
          title: 'はじめに',
          content: 'Alceylan Enterprises（「当社」）は、お客様のプライバシー保護に努めています。このプライバシーポリシーは、当社がどのようにお客様の情報を収集、使用、開示、保護するかを説明しています。',
        },
        collection: {
          title: '収集する情報',
          content: '当社は以下のような方法でお客様の情報を収集する場合があります：',
          items: [
            '個人データ：お問い合わせフォームを通じて提供される氏名、メールアドレス、電話番号、会社情報。',
            '利用データ：当社ウェブサイトへのアクセスと使用方法に関する情報。',
            'Cookie：ブラウジング体験を向上させるためにデバイスに保存される小さなデータファイル。',
          ],
        },
        usage: {
          title: '情報の使用方法',
          content: '収集した情報は以下の目的で使用します：',
          items: [
            'お問い合わせへの対応とカスタマーサポートの提供',
            'ニュースレターやマーケティング通信の送信（同意がある場合）',
            'ウェブサイトとサービスの改善',
            '法的義務の遵守',
          ],
        },
        security: {
          title: 'データセキュリティ',
          content: '当社は、不正アクセス、改ざん、開示、破壊からお客様の個人情報を保護するため、適切な技術的・組織的セキュリティ対策を実施しています。',
        },
        cookies: {
          title: 'Cookieとトラッキング',
          content: '当社はウェブサイトでの活動を追跡するためにCookieや類似のトラッキング技術を使用しています。ブラウザですべてのCookieを拒否するよう設定できます。',
        },
        rights: {
          title: 'お客様の権利',
          content: 'お住まいの地域によっては、個人情報へのアクセス、訂正、削除、エクスポートなどの権利を有する場合があります。',
        },
        contact: {
          title: 'お問い合わせ',
          content: 'このプライバシーポリシーについてご質問がある場合は、以下にお問い合わせください：',
        },
      },
      terms: {
        acceptance: {
          title: '利用規約への同意',
          content: 'Alceylan Enterprisesが提供するサービスにアクセスし使用することにより、お客様はこれらの利用規約に拘束されることに同意したものとみなされます。',
        },
        services: {
          title: '当社のサービス',
          content: 'Alceylan Enterprisesは、技術コンサルティング、ソフトウェア開発、AIソリューション、物流システム、および関連サービスを提供しています。',
        },
        intellectual: {
          title: '知的財産',
          content: '本ウェブサイトに表示されるすべてのコンテンツ、商標、ロゴ、知的財産は、Alceylan Enterprisesまたはそれぞれの所有者の財産です。',
        },
        liability: {
          title: '責任の制限',
          content: 'Alceylan Enterprisesは、当社サービスの使用から生じる間接的、偶発的、特別、結果的、または懲罰的損害について責任を負いません。',
        },
        confidentiality: {
          title: '機密保持',
          content: '両当事者は、ビジネス関係の過程で共有される機密情報または機密性の高い情報の秘密を保持することに同意します。',
        },
        termination: {
          title: '終了',
          content: '当社は、事前の通知なしに、いかなる理由においても、お客様の当社サービスへのアクセスを直ちに終了または停止する場合があります。',
        },
        governing: {
          title: '準拠法',
          content: 'これらの規約は、適用される国際商法に準拠し、それに従って解釈されるものとします。',
        },
        contact: {
          title: 'お問い合わせ先',
          content: 'これらの利用規約についてご質問がある場合は、以下にお問い合わせください：',
        },
      },
    },
  },
  ru: {
    nav: {
      services: 'Услуги',
      about: 'О нас',
      team: 'Команда',
      testimonials: 'Отзывы',
      contact: 'Контакты',
      exploreSolutions: 'Изучить решения',
    },
    hero: {
      headline: 'Используя эмерджентный ИИ. Формируя будущее.',
      subtext: 'Разнообразная технологическая экосистема, движущая эволюцию предприятий через передовой ИИ, индивидуальные SaaS-платформы и глобальные логистические решения.',
      exploreSolutions: 'Изучить решения',
      partnerWithUs: 'Стать партнером',
    },
    services: {
      overline: 'НАШИ РЕШЕНИЯ',
      title: 'Корпоративный технологический стек',
      ai: {
        title: 'Эмерджентные ИИ-решения',
        description: 'ИИ-консалтинг и разработка решений с использованием передового машинного обучения, нейронных сетей и интеллектуальной автоматизации.',
      },
      saas: {
        title: 'Корпоративные SaaS-платформы',
        description: 'Индивидуальные программные решения, включая надежные ERP-системы и CRM-платформы, адаптированные под ваши требования.',
      },
      joinzy: {
        title: 'Joinzy - Социальная экосистема',
        description: 'Наша флагманская платформа социальных сетей, соединяющая сообщества инновационными функциями для вовлечения и нетворкинга.',
      },
      logistics: {
        title: 'Передовые логистические системы',
        description: 'Комплексные решения для управления логистикой и ERP, разработанные для глобальных операций, оптимизации цепочки поставок и отслеживания в реальном времени.',
      },
      gaming: {
        title: 'Разработка онлайн-игр',
        description: 'Создание захватывающих игровых впечатлений с передовой графикой, многопользовательской инфраструктурой и увлекательными игровыми механиками.',
      },
    },
    about: {
      overline: 'НАША ЭКСПЕРТИЗА',
      title: 'Создание доверия через техническое превосходство',
      p1: 'В Alceylan Enterprises мы находимся на пересечении инноваций и надежности. Наша команда инженеров, ученых по данным и бизнес-стратегов мирового класса работает совместно, чтобы предоставлять решения, превосходящие ожидания.',
      p2: 'С приверженностью качеству, которая охватывает каждый проект, мы зарекомендовали себя как надежный партнер для предприятий, стремящихся к цифровой трансформации.',
      p3: 'От концептуализации до развертывания мы обеспечиваем сквозную поддержку, гарантируя, что наши клиенты уверенно достигают своих стратегических целей.',
    },
    team: {
      overline: 'РУКОВОДСТВО',
      title: 'Познакомьтесь с нашей командой',
      members: {
        ceo: { name: 'Arslan Ceylan', title: 'Основатель и CEO' },
        ai: { name: 'Elena Rostova', title: 'Руководитель направления ИИ' },
        logistics: { name: 'Marcus Chen', title: 'VP по логистике и CRM' },
      },
    },
    testimonials: {
      overline: 'ОТЗЫВЫ',
      title: 'Что говорят наши клиенты',
      partners: 'Надежные партнеры',
      items: [
        {
          quote: "ИИ-решения Alceylan повысили нашу операционную эффективность на 40%. Их экспертиза в эмерджентных ИИ-технологиях не имеет равных.",
          author: "Zahide Yildiz",
          role: "Eureka Logistics CEO Founder",
        },
        {
          quote: "Созданная ими ERP-система безупречно интегрируется с нашей глобальной логистической сетью. Исключительное качество и поддержка.",
          author: "Yavus Akcay",
          role: "Eureka Logistics CEO Founder",
        },
      ],
    },
    contact: {
      overline: 'СВЯЗАТЬСЯ С НАМИ',
      title: 'Начните свой проект',
      newsletter: {
        title: 'Будьте в курсе',
        description: 'Подпишитесь на нашу рассылку для получения последних новостей в области корпоративных технологий.',
        placeholder: 'Введите ваш email',
        button: 'Подписаться',
        success: 'Успешная подписка!',
      },
      form: {
        name: 'Полное имя',
        email: 'Email адрес',
        service: 'Интересующая услуга',
        selectService: 'Выберите услугу',
        message: 'Сообщение',
        submit: 'Отправить сообщение',
        sending: 'Отправка...',
        success: 'Сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.',
        error: 'Не удалось отправить. Пожалуйста, попробуйте снова.',
      },
    },
    footer: {
      copyright: '© 2025 Alceylan Enterprises. Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
    },
    legal: {
      lastUpdated: 'Последнее обновление',
      privacy: {
        intro: {
          title: 'Введение',
          content: 'Alceylan Enterprises («мы», «наш» или «нас») стремится защитить вашу конфиденциальность. Настоящая Политика конфиденциальности объясняет, как мы собираем, используем, раскрываем и защищаем вашу информацию.',
        },
        collection: {
          title: 'Информация, которую мы собираем',
          content: 'Мы можем собирать информацию о вас различными способами:',
          items: [
            'Персональные данные: имя, адрес электронной почты, номер телефона и информация о компании, которую вы предоставляете через наши контактные формы.',
            'Данные об использовании: информация о том, как вы получаете доступ к нашему сайту и используете его.',
            'Файлы cookie: небольшие файлы данных, хранящиеся на вашем устройстве для улучшения работы с сайтом.',
          ],
        },
        usage: {
          title: 'Как мы используем вашу информацию',
          content: 'Мы используем собранную информацию для:',
          items: [
            'Ответа на ваши запросы и предоставления поддержки клиентам',
            'Отправки вам новостных рассылок и маркетинговых сообщений (с вашего согласия)',
            'Улучшения нашего сайта и услуг',
            'Соблюдения юридических обязательств',
          ],
        },
        security: {
          title: 'Безопасность данных',
          content: 'Мы применяем соответствующие технические и организационные меры безопасности для защиты вашей личной информации от несанкционированного доступа, изменения, раскрытия или уничтожения.',
        },
        cookies: {
          title: 'Файлы cookie и отслеживание',
          content: 'Мы используем файлы cookie и аналогичные технологии отслеживания для мониторинга активности на нашем сайте. Вы можете настроить браузер на отклонение всех файлов cookie.',
        },
        rights: {
          title: 'Ваши права',
          content: 'В зависимости от вашего местоположения у вас могут быть определенные права в отношении вашей личной информации, включая право на доступ, исправление, удаление или экспорт ваших данных.',
        },
        contact: {
          title: 'Свяжитесь с нами',
          content: 'Если у вас есть вопросы по данной Политике конфиденциальности, свяжитесь с нами по адресу:',
        },
      },
      terms: {
        acceptance: {
          title: 'Принятие условий',
          content: 'Получая доступ к услугам Alceylan Enterprises и используя их, вы соглашаетесь соблюдать настоящие Условия использования.',
        },
        services: {
          title: 'Наши услуги',
          content: 'Alceylan Enterprises предоставляет технологический консалтинг, разработку программного обеспечения, решения в области ИИ, логистические системы и сопутствующие услуги.',
        },
        intellectual: {
          title: 'Интеллектуальная собственность',
          content: 'Весь контент, товарные знаки, логотипы и интеллектуальная собственность, отображаемые на этом сайте, являются собственностью Alceylan Enterprises или их соответствующих владельцев.',
        },
        liability: {
          title: 'Ограничение ответственности',
          content: 'Alceylan Enterprises не несет ответственности за любые косвенные, случайные, специальные, последующие или штрафные убытки, возникающие в результате использования наших услуг.',
        },
        confidentiality: {
          title: 'Конфиденциальность',
          content: 'Обе стороны соглашаются сохранять конфиденциальность любой служебной или конфиденциальной информации, переданной в ходе наших деловых отношений.',
        },
        termination: {
          title: 'Прекращение',
          content: 'Мы можем немедленно прекратить или приостановить ваш доступ к нашим услугам без предварительного уведомления по любой причине.',
        },
        governing: {
          title: 'Применимое право',
          content: 'Настоящие Условия регулируются и толкуются в соответствии с применимым международным коммерческим правом.',
        },
        contact: {
          title: 'Контактная информация',
          content: 'По любым вопросам относительно настоящих Условий использования обращайтесь к нам по адресу:',
        },
      },
    },
  },
};

export const languageNames = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  zh: '中文',
  ja: '日本語',
  ru: 'Русский',
};
